<div class="tw-relative tw-rounded tw-bg-divider/80 tw-p-10 tw-text-center">
  <button
    (click)="close()"
    class="tw-absolute tw-right-0 tw-top-0 tw-cursor-pointer tw-bg-transparent tw-p-2.5 tw-opacity-50 hover:tw-opacity-80"
  >
    <p-icon name="close"></p-icon>
  </button>
  <form [formGroup]="form" (ngSubmit)="submit()" [class.show-form-error]="showFormError">
    <div class="tw-mb-5">
      <h1 class="p-text-h3">Want to learn more?</h1>
      <p class="p-text-p tw-mt-2.5">Reach out to {{ issuerName }} to find out.</p>
    </div>

    <div class="tw-text-left">
      <div class="input-panel">
        <div class="input-label">{{ 'common.subject' | translate }}</div>
        <input
          type="text"
          class="form-control"
          formControlName="subject"
          [placeholder]="'common.subject' | translate"
        />
      </div>

      <div class="input-panel">
        <div class="input-label">{{ 'common.message' | translate }}</div>
        <textarea
          type="text"
          class="form-control"
          formControlName="message"
          [placeholder]="'common.message' | translate"
        ></textarea>
      </div>

      <button type="submit" class="btn btn-green tw-mt-5 tw-w-full">
        {{ 'common.submit' | translate }}
      </button>
    </div>
  </form>
</div>
